export default {
    margin: 0.75,
    padding: 0.4,
    radius: 0.35,
    size: 0.9,
};
